/* eslint-disable */
if (!Date.now) {
  Date.now = function () {
    return new Date().getTime();
  };
}
var vendors = ['ms', 'moz', 'webkit', 'o'];
for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
  var vendor = vendors[i];
  window.requestAnimationFrame = window[vendor + 'RequestAnimationFrame'];
  window.cancelAnimationFrame = (window[vendor + 'CancelAnimationFrame']
  || window[vendor + 'CancelRequestAnimationFrame']);
}
// iOS6 is buggy
if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
  var lastTime = 0;
  window.requestAnimationFrame = function (callback) {
    var now = Date.now();
    var nextTime = Math.max(lastTime + 16, now);
    return setTimeout(function () {
        callback(lastTime = nextTime);
      }, nextTime - now);
  };
  window.cancelAnimationFrame = clearTimeout;
}

export default {
  requestAnimationFrame: function (callback) {
    return window.requestAnimationFrame(callback);
  },
  cancelAnimationFrame: function (requestID) {
    return window.cancelAnimationFrame(requestID);
  }
}



// WEBPACK FOOTER //
// ./packages/utils/requestAnimationFrame.js